// Générateur pseudo-aléatoire déterministe (mulberry32) + graine du défi du jour.
// Pur — permet de rejouer la même partie quotidienne partout.
export function mulberry32(a: number) {
  return function () {
    a |= 0; a = a + 0x6D2B79F5 | 0;
    let t = Math.imul(a ^ a >>> 15, 1 | a);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}

// Graine du défi du jour : date UTC (YYYYMMDD). UTC et PAS le fuseau local : le défi est MONDIAL
// (classement quotidien partagé) — en heure locale, « la même journée » donnerait des graines
// différentes selon le fuseau (Tokyo et Los Angeles ne joueraient jamais le même défi au même
// moment) et le classement se fragmenterait. Le serveur valide d'ailleurs la graine en UTC
// (functions/api/score.validDailySeed) : tout le monde bascule au même instant, minuit UTC.
export function todaySeed(): string {
  const d = new Date();
  return '' + d.getUTCFullYear() + String(d.getUTCMonth() + 1).padStart(2, '0') + String(d.getUTCDate()).padStart(2, '0');
}
